// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"style__chartContainer__0Gi-J","title":"style__title__Rmh9m","component":"style__component__SSTag","chart":"style__chart__oWvFU"};